import { useIntl } from '@/intl'
import { ShowMore } from '@/scopes/common/components/ShowMoreUDS'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useSelectFilter } from '@/scopes/search/search/domain/hooks'
import { CheckedChangedEventHandler } from '@sunwebgroup/ui-components'
import { Accordion } from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import ListFilterItem from './ListFilterItem'

export function HasAvailabilityNextSeasonFilter() {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { options, selectedValue, isFetching, setSelection } = useSelectFilter('HasAvailabilityNextSeason')

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      setSelection(value)
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'has availability',
          result: value,
        }),
      )
    }
    else {
      setSelection(undefined)
    }
  }

  if (isEmpty(options))
    return null

  return (
    <Accordion.Item title={intl.formatMessage({ id: 'search_filter_has_availability_label' })} defaultOpen>
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
        visibleItems={4}
      >
        {options.map(({ name, value, resultsCount }) => (
          <ListFilterItem.Checkbox
            key={name}
            label={name}
            counter={resultsCount}
            checked={selectedValue === value}
            value={value}
            onChange={handleFilterChange}
            disabled={isFetching}
          />
        ))}
      </ShowMore>
    </Accordion.Item>
  )
}
